export const COLORS = {
  SIDEBAR: "#1e2124",
  WHITE: "#ffffff",
  MODAL_BACK: "#dcdcdc",
  BORDER: "#424549",
  BUTTON: "#7289da",
  BACKGROUND: "#424549",
  VIEW_BACKGROUND: "#36393e",
  BTN: "#7289da",
  GRAY: "#c8c8c8",
  LOGIN: "#FFD0A1",
  BLUE: "#1E82FF",
  BLUE_HOVER: "#28A0FF",
  RED: "#EB0000",
  RED_HOVER: "#ff4646",
  SPINNER: "#ccc",
  TOAST: "#dcebff",
};

export const TIME = {
  DETAIL_TRANSITION: 0.7,
  SIDE_DROPDOWN: 0.5,
};

export const SIZE = {
  BIG_LOGO: 60,
  PAGEHEADER_LOGO: 30,
  FONT_PAGEHEADER: 40,
  FONT_TITLE: 24,
  FONT_INPUT: 20,
  FONT_REGULAR: 18,
  FONT_NORMAL: 16,
  FONT_SMALL: 14,
  PADDING: 10,
  MARGIN: 10,
  BORDER_RADIUS: 5,
};

export const CHART_COLORS = [
  "#C8FFFF",
  "#98FB98",
  "#f491e6",
  "#FFF978",
  "#FF8C8C",
  "#F5AF64",
  "#5ABEFF",
  "#78EFAD",
  "#FFA5F0",
  "#FFF064",
  "#F88EF4",
  "#6EE5A3",
  "#cba9b2",
  "#e2efd0",
  "#a1f7af",
  "#8bb8d0",
  "#C8FFFF",
  "#98FB98",
  "#f491e6",
  "#FFF978",
  "#FF8C8C",
  "#F5AF64",
  "#5ABEFF",
  "#78EFAD",
  "#FFA5F0",
  "#FFF064",
  "#F88EF4",
  "#6EE5A3",
  "#cba9b2",
  "#e2efd0",
  "#a1f7af",
  "#8bb8d0",
];
